import localeSettings from './settings';
import zhCNJSON from './zh-CN.json';
import localeLogin from '@/views/login/locale/zh-CN';

export default {
    ...localeSettings,
    ...localeLogin,
    ...zhCNJSON,
};
